export const environment = {
  production: true,
  // apiUrl: 'http://10.5.1.7/perasis/api/',
  // apiBaseUrl: 'http://10.5.1.7/perasis',
  // apiUrl: 'https://api.jetsinif.com/api/',
  // apiBaseUrl: 'https://api.jetsinif.com',
  // apiUrl: 'https://10.5.1.58:45456/api/',
  // apiBaseUrl: 'https://10.5.1.58:45456',  
  apiUrl: 'https://peak-api.perasis.com/api/',
  apiBaseUrl: 'https://peak-api.perasis.com',
};
